<h2 class="dash">About</h2>

<!-- Add link to itch, and scirra -->
<!-- https://www.construct.net/en/free-online-games/profile/reflextions-28351 -->
<!-- https://reflextions.itch.io/ -->
<!-- https://www.indiedb.com/company/reflextions -->
<div class="content">
    <div class="content__text">
        <p>
            As a solo developer, I've worn many hats. I've taken games through
            their full lifecycle: handling all aspects of designing, developing,
            testing, and publishing. But I'm no stranger to getting in the
            weeds. I follow the idea of a π shaped skillset, wherein I specialize
            in design and development.
        </p>
        <p>
            I've published projects on Steam, Google Play, and the App Store. My
            HTML5 games have reached millions of players and I've participated in a few game jams. I've worked as a freelancer on many projects, including apps, educational games, and games published as op-eds.
        </p>
        <!-- <p>
            Scroll down to see <a href="">what I'm working on</a> now and my <a href="">game archive</a>. Alternatively, check out my <a href="">design portfolio</a> or get more <a href="">info about hiring</a>. 
        </p> -->
        <p>
            Scroll down to see my finished projects to date.
        </p>
    </div>
</div>
